var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "col col-sm-12 col-md-6 col-lg-4 teaser--deals",
      attrs: {
        href:
          _vm.baseUrl +
          (_vm.lang === "de" ? "/angebote/" : "/it/offerte/") +
          _vm.item.Id +
          "/"
      }
    },
    [
      _c("figure", { staticClass: "figure figure--thumbnail" }, [
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            src: _vm.dealImage(_vm.item),
            width: "500",
            height: "340",
            loading: "lazy",
            alt: _vm.item.TypeNameFull ? _vm.item.TypeNameFull : ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "teaser__content--deals" }, [
        _c("p", { staticClass: "h4 teaser__title--deals font-weight-bold" }, [
          _vm._v(_vm._s(_vm.item.TypeNameFull ? _vm.item.TypeNameFull : ""))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "h4 font-color-secondary" }, [
          _vm._v(_vm._s(_vm.convertToCurrency(_vm.item.Price)))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "title--small" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                "" +
                  (_vm.item.TransmissionTypeText
                    ? _vm.item.TransmissionTypeText + " | "
                    : "") +
                  (_vm.item.FuelTypeText ? _vm.item.FuelTypeText + " | " : "") +
                  _vm.item.BodyTypeText +
                  " | " +
                  (_vm.item.Hp
                    ? _vm.item.Hp + " " + _vm.lexicon.hp + " | "
                    : "") +
                  _vm.item.BodyColorText +
                  " | " +
                  _vm.item.ConditionTypeText +
                  " | " +
                  _vm.item.Km +
                  " Km"
              ) +
              "\n    "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }